const width = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tabletS: '550px',
  tabletL: '768px',
  laptopS: '1024px',
  laptopM: '1200px',
  laptopL: '1440px',
  desktop: '2560px'
}

export const mediaQueries = {
  mobileS: `(max-width: ${width.mobileS})`,
  mobileM: `(max-width: ${width.mobileM})`,
  mobileL: `(max-width: ${width.mobileL})`,
  tabletS: `(max-width: ${width.tabletS})`,
  tabletL: `(max-width: ${width.tabletL})`,
  laptopS: `(max-width: ${width.laptopM})`,
  laptopM: `(max-width: ${width.laptopM})`,
  laptopL: `(max-width: ${width.laptopL})`,
  desktop: `(max-width: ${width.desktop})`
}
